const common = {
  nav: {
    about: 'Rreth Meje',
    services: 'Shërbime',
    credentials: 'Kredencialet',
    contact: 'Kontakt',
    insights: 'Refleksione',
    cta: 'Rezervo Konsultë',
  },
  footer: {
    badge: 'Analiste Klinike e Grupit',
    tagline: 'Duke lidhur njohjen e thellë psikologjike me realitetin organizativ praktik. Me seli në Tiranë, duke shërbyer klientët ndërkombëtarisht.',
    navTitle: 'Navigimi',
    about: 'Rreth Meje',
    services: 'Shërbime të Ofruara',
    credentials: 'Kredencialet',
    contact: 'Kontakt',
    affiliations: 'Asociacionet Profesionale',
    iga: 'Instituti i Analizës së Grupit (IGA)',
    igaProgram: 'Programi Ndërkombëtar UK',
    location: 'Tiranë, Shqipëri',
    languages: 'Anglisht · Italisht · Shqip',
    copyright: '© 2026 Mirela. Të gjitha të drejtat e rezervuara.',
  },
  about: {
    hero: {
      badge: 'Konsulente & Psikoterapeute\nSisteme, Grupe dhe Dinamika Organizative',
      heading: 'Përshëndetje, emri im është Mirela Bregu. Jam konsulente organizative dhe terapeute e çertifikuar e grupit.',
      intro: 'Një praktikë e ndërtuar mbi dekada eksperiencë në kryqëzimin e zhvillimit personal, biznesit dhe sistemeve njerëzore — duke shërbyer klientë në Tiranë dhe ndërkombëtarisht.',
      cta1: 'Na Kontaktoni',
      cta2: 'Shiko Shërbimet',
      stat1: 'Vite Eksperiencë',
      stat2: 'Gjuhë të Ofruara',
      stat3: 'Çertifikuar IGA',
      locationLabel: 'Vendndodhja e Praktikës',
      locationValue: 'Tiranë, Shqipëri',
    },
    bg: {
      badge: 'Prejardhja',
      headlinePart1: 'Dekada në kryqëzimin e',
      headlineEm: 'biznesit dhe sjelljes njerëzore',
      p1: 'Karriera ime është karakterizuar nga një interes i thellë për mënyrën si njerëzit funksionojnë brenda mjediseve të strukturuara. Kam kaluar dekada duke naviguar kompleksitetin e zhvillimit të biznesit, koordinimit të projekteve dhe menaxhimit organizativ — role që kërkojnë kuptim të mprehtë të sjelljes njerëzore, komunikimit dhe shëndetit sistemik.',
      p2: 'Nuk i shoh individët të izoluar; unë shoh rrjetet, historitë dhe grupet që i formojnë ata. Ky këndvështrim sistemik informon çdo aspekt të praktikës sime klinike.',
      trainingBadge: 'Trajnim dhe Kredenciale',
      trainingText: 'Jam eksperte klinike e trajnuar nga Instituti i Analizës së Grupit (IGA), Programi Ndërkombëtar UK. Ky trajnim rigoroz, i kombinuar me përvojën time të gjerë në sektorin profesional, më lejon të mbush hendekun midis njohjes psikologjike të thellë dhe realitetit organizativ praktik.',
      verified: 'Analiste e Grupit · Çertifikuar IGA',
      practiceBadge: 'Praktika',
      practiceText: 'Praktika ime ndodhet në Tiranë, ku shërbej një klientelë të larmishme në anglisht, italisht dhe shqip — duke ofruar një hapësirë të informuar ndërkombëtarisht por të rrënjosur lokalisht.',
    },
    approach: {
      badge: 'Qasja Ime',
      quote: 'I shoh sfidat si ankthin, djegien profesionale ose konfliktin si sinjale të çështjeve sistemike më të thella — jo probleme për t\'u menaxhuar, por të vërteta për t\'u kuptuar.',
      s1Title: 'Dinamikat Organizative',
      s1Desc: 'Zbulimi i forcave të padukshme që formojnë kulturën e vendit të punës dhe sjelljen e grupit.',
      s2Title: 'Coaching për Lidershipin',
      s2Desc: 'Një hapësirë konfidenciale për liderët të përpunojnë barrën psikologjike të vendimmarrjes.',
      s3Title: 'Çështjet Relacionale',
      s3Desc: 'Eksplorimi i modeleve relacionale brenda konteksteve individuale dhe të çiftit.',
      s4Title: 'Kohezioni i Grupit',
      s4Desc: 'Lehtësimi i besimit, komunikimit dhe përkitjes brenda ekipeve dhe komuniteteve.',
      s5Title: 'Rritja Personale',
      s5Desc: 'Mbështetja e transformimeve të qëndrueshme nëpërmjet vetë-reflektimit dhe vizionit sistemik.',
      s6Title: 'Mjedisi Mbajtes',
      s6Desc: 'Një hapësirë e sigurt, konfidenciale dhe transparente për të eksploruar të vërteta të vështira pa gjykim.',
      method: 'Qasja ime bazohet kryesisht në Psikoterapi Psikoanalitike të Grupit. Gjatë sesioneve, unë lehtësoj një proces të asociimit të lirë dhe reflektimit. Për klientët organizativë, përdor mendimin Sisteme-Psikodinamike për t\'ju ndihmuar të shikoni forcat e padukshme në kulturën tuaj të punës. Ne nuk fokusohemi vetëm tek simptomat e menjëhershme — shikojmë jetën e pavetëdijshme të grupit ose individit.',
    },
    cred: {
      iga: 'Instituti i Analizës së Grupit (IGA), UK',
      languages: 'Anglisht · Italisht · Shqip',
      location: 'Praktikë në Tiranë, Shqipëri',
    },
  },
  services: {
    hero: {
      badge: 'Çfarë Ofroj',
      title: 'Shërbime të Ofruara',
      subtitle: 'Fillimi i terapisë ose konsultancës është një hap i rëndësishëm drejt vetë-kuptimit. Qoftë individ, çift ose organizatë, unë ofroj një hapësirë rigoroze, të mëshirshme dhe të bazuar në dëshmi.',
    },
    sectionBadge: 'Specializimet Kryesore',
    c1Tag: 'Oferta Kryesore',
    c1Title: 'Psikoterapi Psikoanalitike e Grupit',
    c1Desc: 'Seanca javore për individët që kërkojnë të eksplorëjnë modelet e tyre relacionale brenda një grupi mbështetës. Grupi bëhet mikrokozmosi i botës sociale, një vend për të kuptuar veten nëpërmjet të tjerëve.',
    c2Tag: 'Individual',
    c2Title: 'Terapi Psikodinamike Individuale',
    c2Desc: 'Punë individuale e fokusuar mbi tranzicionet personale, identitetin dhe mirëqenien emocionale.',
    c3Tag: 'Organizata',
    c3Title: 'Organisational Dynamics',
    c3Desc: 'Mbështetje e specializuar për liderët dhe ekipet për të përmirësuar kohezioni e grupit, komunikimin dhe shëndetin organizativ nëpërmjet lenteve sisteme-psikodinamike.',
    c4Tag: 'Lidership',
    c4Title: 'Leadership\u00a0Coaching and\u00a0Reflective Practice\u00a0',
    c4Desc: 'Një hapësirë konfidenciale për drejtuesit të përpunojnë barrën psikologjike të lidershipit, përgjegjësinë strategjike dhe izolimin që shpesh shoqëron vendimmarrjen. When needed, through the use of International Preferences Indicator (IPI), and The International Profile (TIP)',
    c5Tag: 'Profesionistë',
    c5Title: 'Supervizim dhe Mentorship',
    c5Desc: 'Supporting professionals to enhance their practice through a systemic and group-analytic lens.',
    dir: {
      badge: 'Direktoria e Plotë',
      offered: 'Shërbime të Ofruara',
      worksWith: 'Punon Me',
      areas: 'Fushat e Ekspertizës',
      profTitle: 'Titulli Profesional',
      groupAnalyst: 'Analiste e Grupit',
      servicesList: ['Coaching', 'Menaxhimi i Konflikteve', 'Konsultim', 'Workshops Korporative', 'Terapi Grupi', 'Psikoterapi Individuale', 'Terapi Online', 'Këshillim Relacional', 'Supervizim dhe Trajnim', 'Grupe Mbështetëse'],
      workList: ['Të Rritur', 'Komunitete', 'Çifte', 'Të Moshuar', 'Familje', 'Grupe', 'Organizata', 'Prindër', 'Individë'],
      areasList: ['Ankth', 'Çështje Karriere', 'Ndërkultural', 'Ballafaqim me Divorcin', 'Çështje Familjare', 'Faj ose Falje', 'Tranzicionet e Jetës', 'Mbështetje Prindërore', 'Stres / Djegie Profesionale', 'Vetëvlerësim'],
    },
    fees: {
      badge: 'Tarifat dhe Info Seancash',
      headline: 'E qartë, fleksibël dhe e aksesueshme',
      subtext: 'Starting therapy or consultancy is a significant step toward self-understanding. If you are looking for a therapist who understands the complex interplay between the individual and the group, I invite you to reach out for an initial consultation.',
      type1Label: 'Terapi Psikodinamike Individuale',
      type1Duration: 'Seanca 50-minutëshe',
      type1Frequency: 'Javore ose dygjavshmëre',
      type1Format: 'Personalisht (Tiranë) ose online',
      type2Label: 'Psikoterapi Psikoanalitike e Grupit',
      type2Duration: 'Seanca 90-minutëshe',
      type2Frequency: 'Javore — grup i vazhdueshëm',
      type2Format: 'Personalisht (Tiranë) ose online',
      type3Label: 'Konsultim Organizativ',
      type3Duration: 'Gjatësi e personalizuar',
      type3Frequency: 'E përshtatur me fushën e projektit',
      type3Format: 'Në vend ose online',
      type4Label: 'Praktikë Reflektuese e Lidershipit',
      type4Duration: 'Seanca 60-minutëshe',
      type4Frequency: 'Rekomandohet javore ose çdo dy javë',
      type4Format: 'Personalisht ose online',
      feeNoticeTitle: 'Një shënim mbi tarifat',
      feeNoticeText: 'Tarifat ndryshojnë sipas llojit të shërbimit, frekuencës së seancave dhe rrethanave individuale. Synojë të jem transparente dhe e aksesueshme — nëse keni shqetësime rreth përballueshmërisë financiare, ju inkurajoj t\'i ngrisni gjatë bisedës sonë fillestare.',
      feeNoticeNote: 'Marrëveshjet me tarifë të reduktuar mund të jenë të disponueshme në raste të caktuara. Ju lutemi pyesni drejtpërdrejt.',
      introTitle: 'Konsultim Fillestar Falas',
      introText: 'A complimentary 30-minute introductory consultation to discuss your needs, ask questions, and explore whether my approach is the right fit for you. The consultation can be held in presence or online.',
      introBtn: 'Rezervoni telefonatën tuaj falas',
      onlineTitle: 'I Disponueshëm Online',
      onlineText: 'Të gjitha seancat individuale dhe coaching janë të disponueshme nëpërmjet videokomunikimit të sigurt për klientët në të gjithë Europën dhe ndërkombëtarisht.',
    },
    cta: {
      title: 'Gati për të Filluar?',
      desc: 'Nëse po kërkoni një terapist që kupton ndërveprimin kompleks midis individit dhe grupit, ju ftoj të na kontaktoni për një konsultim fillestar.',
      btn: 'Rezervo Konsultën',
    },
  },
  contact: {
    hero: {
      badge: 'Na Kontaktoni',
      title: 'Lidhuni me Ne',
      subtitle: 'Bëni një pyetje të shpejtë ose organizoni një kohë takimi. Synoj të përgjigjem brenda 48 orëve.',
    },
    form: {
      name: 'Emri i Plotë',
      namePlaceholder: 'Emri juaj',
      email: 'Adresa Email',
      emailPlaceholder: 'ju@shembull.com',
      phone: 'Numri i Telefonit',
      phoneOptional: '(opsional)',
      phonePlaceholder: '+355 XX XXX XXXX',
      service: 'Shërbimi i Interesit',
      serviceDefault: 'Zgjidhni një shërbim…',
      service1: 'Psikoterapi Psikoanalitike e Grupit',
      service2: 'Terapi Psikodinamike Individuale',
      service3: 'Konsultim Organizativ',
      service4: 'Praktikë Reflektuese e Lidershipit',
      service5: 'Supervizim dhe Mentorship',
      service6: 'Nuk jam i/e sigurt akoma',
      preferred: 'Metoda e Preferuar e Kontaktit',
      contactEmail: 'Email',
      contactPhone: 'Telefon',
      contactEither: 'Çdo metodë',
      message: 'Mesazhi',
      messagePlaceholder: 'Bëni një pyetje, ose tregomni pak çfarë po kërkoni…',
      submit: 'Dërgo Mesazhin',
      sending: 'Duke dërguar…',
      privacy: 'Informacioni juaj është konfidencial dhe nuk do të ndahet.',
      successTitle: 'Mesazhi u Dërgua',
      successDesc: 'Faleminderit që na kontaktuat. Do t\'ju kontaktoj së shpejti për të organizuar një kohë takimi.',
      successBtn: 'Dërgo Mesazh Tjetër',
      error: 'Diçka shkoi keq. Ju lutemi provoni përsëri ose na kontaktoni drejtpërdrejt.',
    },
    info: {
      email: 'Email',
      phone: 'Telefon',
      location: 'Vendndodhja',
      langTitle: 'Gjuhët',
      availTitle: 'Disponibiliteti',
      availText: 'Seancat disponohen personalisht në Tiranë dhe online për klientët ndërkombëtarë. Konsultimet fillestare disponohen me caktim kohe.',
    },
    loc: {
      badge: 'Vendndodhja e Praktikës',
      title: 'Me seli në Tiranë, duke shërbyer klientët ndërkombëtarisht',
      text: 'Praktika ndodhet në Tiranë, Shqipëri. Terapia online dhe konsultimi janë të disponueshme për klientët në të gjithë Europën dhe më gjerë. Të gjitha seancat janë rreptësisht konfidenciale.',
    },
  },
  coreCompetencies: {
    badge: 'Core Competencies',
    quote: "We don't live or work in isolation; we exist within 'constellations, our families, our teams, and within our organizations.",
    paragraph: "My approach is primarily Group Psychoanalytic Psychotherapy with specializations in: Organizational Dynamics, Leadership Coaching, Relationship Issues, Group Cohesion, and Personal Growth. We don't just focus on immediate symptoms; we look at the 'unconscious' life of the group or the individual. I view challenges like anxiety, burnout, or conflict as signals of deeper systemic issues.",
    c1Title: 'Institutional Building & Governance',
    c1Desc: 'Establishing professional, merit-based cultures and aligning executive teams using advanced coaching and group dynamics tools.',
    c2Title: 'Development Banking',
    c2Desc: 'Scaling financial operations from simple product offices to full commercial business lines, grounded in the ProCredit and Intesa Sanpaolo models.',
    c3Title: 'Organizational Transformation & Performance',
    c3Desc: 'Leading large-scale cultural shifts and re-engineering business processes to increase institutional agility and performance.',
    c4Title: 'Leadership Development',
    c4Desc: 'Understanding the needs of Executive & Team Performance for Coaching and support, to accelerate leadership capabilities and institutional cohesion.',
  },
  education: {
    badge: 'Education',
    certsBadge: 'Advanced Certifications',
    academicBadge: 'Academic & Volunteer Experience',
    academicText: 'Early in my career, I served as a Seminar Leader at the University of Tirana, teaching Basis of Marketing and International Business, before going on to chair the Board of Junior Achievement Albania. I subsequently led seminars in Credit Management and Bank Simulation at FASTIP, Aleksander Moisiu University, and currently serve as General Secretary of Group Analysis Albania — a non-profit member of GASI and EGATIN.',
    d1Degree: 'Qualified Group Analyst (QGA)',
    d1Institution: 'Institute of Group Analysis (IGA)',
    d1Location: 'London',
    d1Period: '2019 – 2024',
    d2Degree: 'Master of Business Administration (MBA)',
    d2Institution: 'University of Nebraska-Lincoln / University of Tirana',
    d2Period: '2002 – 2004',
    d3Degree: "Bachelor's Degree in Finance",
    d3Institution: 'University of Tirana',
    d3Period: '1991 – 1995',
    cert1Title: 'The International Profiler (TIP – next gen)',
    cert1Issuer: 'Global Agility Tools',
    cert2Title: 'International Preferences Indicator (IPI next gen)',
    cert2Issuer: 'Global Agility Tools',
    cert3Title: 'Digital Business & Entrepreneurial Toolbox',
    cert3Issuer: 'EBRD',
    cert4Title: 'Change Management for Consulting',
    cert4Issuer: 'EBRD',
    cert5Title: 'Foundation Course in Group Analysis',
    cert5Issuer: 'IGA Accredited',
    cert6Title: 'Harvard ManageMentor',
    cert6Issuer: 'Harvard Business Publishing',
  },
  experience: {
    badge: 'Working Experience',
    j1Title: 'Consultant (Albania)',
    j1Org: 'FBI Consulting ShPK',
    j1Period: 'October 2017 – Present',
    j1b1: 'Managed organizational restructuring and change management, optimizing job descriptions and incentive/bonus systems.',
    j1b2: 'Assisted Startups and SMEs with adapting business strategy, understanding customer base, and re-engineering internal workflows and processes between different functional departments.',
    j1b3: 'Employed Group-analysis methodology to facilitate dialogue and organizational health. Provided psychotherapy/coaching to individuals and groups.',
    j2Title: 'Head of Retail Banking Division (Albania)',
    j2Org: 'Tirana Bank – PIRAEUS BANK Group',
    j2Period: 'November 2013 – June 2017',
    j2b1: 'Developed and implemented the Retail Strategy and Action-Plans, managing all retail banking activities: Products & Services, Cards & Electronic-channels, and Marketing.',
    j2b2: 'Re-engineered processes and workflows through product mix optimization and introduction of incentives to boost sales.',
    j2b3: 'Evaluated procedures and processes at Branch and Division levels to ensure efficiency, effectiveness, and compliance with internal policies and regulatory requirements.',
    j3Title: 'Executive Director (Uganda)',
    j3Org: 'PEARL MICROFINANCE',
    j3Period: 'July 2012 – March 2013',
    j3b1: 'Led the turnaround project of the institution (14 branches, 140 employees) facing limited resources, achieving break-even within a 4-month timeframe.',
    j3b2: 'Improved institutional culture and led the reorganization/creation of several key departments (legal, administration, operations).',
    j3b3: 'Built capacity by introducing training programs, incentive payment schemes, and implementing mobile money payment systems.',
    j3b4: 'Successfully implemented a new MIS with detailed processes/procedures and proper data migration.',
    j4Title: 'Senior Consultant, Principal (Projects in Pacific Islands, Uganda, Ghana)',
    j4Org: 'A2F Consulting',
    j4Period: 'October 2011 – June 2012',
    j4b1: 'Provided strategy, advisory, and operational consulting focusing on process re-engineering, change management, and product mix optimization.',
    j4b2: 'Implemented tools for liquidity management, loan monitoring, and credit risk management, and developed department reporting frameworks.',
    j5Title: 'Manager-Coordinator of Retail Team (Bank of Qingdao Project, China)',
    j5Org: 'INTESA SANPAOLO S.p.A., ISBD',
    j5Period: '2009 – 2011',
    j5b1: 'Provided know-how and capacity building to foster the Retail Business Development of the Bank of Qingdao (BQD).',
    j5b2: 'Revised, differentiated, and enriched the basic product catalog by analyzing customer base and usage rates.',
    j5b3: 'Designed the appropriate Retail Service Model and led the development of the internal structure from simple transaction offering to full service/advisory.',
    j5b4: 'Led the development of the common branch layout model, basic branch revamping, and standardized the process for BTL marketing materials.',
    j6Title: 'Consultant, Retail Business Development Office',
    j6Org: 'INTESA SANPAOLO S.p.A., ISBD (Italy)',
    j6Period: '2008 – 2009',
    j6b1: 'Coordinated Retail activities and strategies across the International Subsidiary Banks Division (ISBD) scope of project.',
    j6b2: "Supported the launch of innovative products/services and propagated ISP Group's Best Practices.",
    j7Title: 'Manager, Network Expansion',
    j7Org: 'INTESA SANPAOLO Bank Albania (former ABA, Albania)',
    j7Period: '2004 – 2007',
    j7b1: 'Responsible for all aspects of planning, coordinating, and ensuring successful bank expansion.',
    j7b2: 'Managed Geo-Market study, negotiated legal contracts, supervised construction, and coordinated all internal departments and third parties (local government, Central Bank).',
    j8Title: 'Earlier Career',
    j8Org: 'INTESA SANPAOLO Bank Albania',
    j8Period: '2002 – 2008',
    j8b1: 'Held roles as: Manager Statistics and Reporting Card, Services Department; Supervisor, Compliance Operations; Internal Audit.',
    j9Title: 'Earlier Career',
    j9Org: 'PROCREDIT Group (Albania)',
    j9Period: '1996 – 2002',
    j9b1: 'Held roles as: Regional Manager, Micro LO, SME LO, and Branch Manager.',
    j9b2: 'Coordinated, controlled, and decided on all operational issues within the region.',
    j9b3: 'Planned, selected, and evaluated regional staff, and ensured the achievement of targets set by management.',
  },
  insights: {
    hero: {
      badge: 'Refleksione dhe Shkrime',
      title: 'Refleksione',
      subtitle: 'Refleksione mbi dinamikat e grupit, jetën organizative dhe funksionimin e brendshëm të mendjes — ndarë fillimisht në LinkedIn.',
      linkedinCta: 'Ndiq në LinkedIn',
    },
    featuredLabel: 'E Rekomanduar',
    readMore: 'Lexo më shumë',
    minRead: 'min lexim',
    filterAll: 'Të gjitha',
    empty: 'Nuk u gjetën artikuj në këtë kategori.',
    watchVideo: 'Shiko videon',
    includesVideo: 'Përfshin video',
    viewOnLinkedIn: 'Shiko postimin origjinal në LinkedIn',
    ctaTitle: 'Më shumë në LinkedIn',
    ctaSubtext: 'Ndiq Mirelën në LinkedIn për të marrë refleksione të reja dhe përditësime profesionale sapo të publikohen.',
    ctaBtn: 'Ndiq në LinkedIn',
  },
};

export default common;
